import React from 'react'
import ReadmoreDiscricption from './ReadmoreDiscricption'

function CreateAndEditDynamicTable(props) {
  const { previewData } = props
  const handleEditClick = data => {
    if (data.PK === 'movieLists') {
      return window.open('editList?' + encodeURI(data.movieListID.replace('#', '$')))
    }

    window.open('editmovie?' + encodeURI(data.PK))
  }

  return (
    <table className='tableclassName sticky-thc' style={{ width: '100%' }}>
      <tr
        style={{
          backgroundColor: 'lightgray',
          zIndex: '1',
          position: 'relative',
          border: '1px solid black',
        }}
      >
        <th className='tdclassName'>S.No</th>
        <th className='tdclassName'>Actions</th>

        {Object.keys(previewData[0]).map((e, index) => {
          if (e === 'SK' || e === 'movieID') {
            return ''
          }

          return (
            <th className='tdclassName' key={index}>
              {e}
            </th>
          )
        })}
      </tr>

      {previewData &&
        previewData.map((data, index) => (
          <tr key={index}>
            <td className='tdclassName'>{index + 1}</td>
            <td className='tdclassName'>
              {' '}
              <button style={{ border: '1px solid black', borderRadius: '7px', margin: '2px' }}>
                <span
                  className='fas fa-pencil-alt fa-lg'
                  onClick={() => handleEditClick(data && data)}
                ></span>
              </button>
            </td>
            {Object.keys(data) &&
              Object.keys(data).map((datakey, index) => {
                if (datakey === 'SK' || datakey === 'movieID') {
                  return ''
                }

                return (
                  <ReadmoreDiscricption key={index} datakey={datakey} data={data} index={index} />
                )
              })}
          </tr>
        ))}
    </table>
  )
}

export default CreateAndEditDynamicTable
